<template>
  <div class="plaid-security-info">
    <div
      v-for="(item, index) in itemList"
      :key="index"
      class="plaid-security-info__item"
    >
      <img
        class="plaid-security-info__item-image"
        :src="item.imgSrc"
        alt=""
      >
      <div class="plaid-security-info__item-text">
        {{ item.text }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PlaidSecurityInfo',
  data () {
    return {
      itemList: [
        {
          imgSrc: require('@/assets/svg/plaid/Icon-Eye.svg'),
          text: 'Spring does not store or view any banking credentials'
        },
        {
          imgSrc: require('@/assets/svg/plaid/Icon-Lock.svg'),
          text: 'We use top-level security measures to keep your information safe'
        },
        {
          imgSrc: require('@/assets/svg/plaid/Icon-Security.svg'),
          text: 'We cannot make transactions on your behalf'
        }
      ]
    }
  }
}
</script>

<style scoped lang="scss">
.plaid-security-info {
  @apply my-20;

  &__item {
    @apply flex my-10 bg-white py-20 border border-gray-300 rounded-10;

    &-image {
      @apply pl-10 pr-5 mx-10;
    }

    &-text {
      @apply mt-5 px-5 text-left text-md sm:text-base;
    }
  }
}
</style>
